import React from "react";

const Footer = () => {
  return (
    <footer>
      <h2>
        If you have any project or would like to have discussion, please feel
        free to reach!
      </h2>
      <div className="footer_links">
        <a
          href="https://docs.google.com/document/d/e/2PACX-1vSjVfn6IHsqlojy6KDW_ycXLOz62YtO2qKV9ViT2OlFrBmpP3ugrE-HUas5XifLi7PyyAlLFQMhVdk0/pub"
          rel="noreferrer"
          target="_blank"
        >
          Download Resume
        </a>
      </div>
      <p>&copy; {new Date().getFullYear()}. Created by Shubham</p>
    </footer>
  );
};

export default Footer;
